import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  grid: {
    // DS defect: MuiCheckbox disabled-and-checked paints a white tick on
    // primary[100], which is 1.18:1 and so reads as unchecked. Assigned and GA
    // rows are exactly that state, so without this the tenant looks like it
    // holds no flags. Raised with the DS separately; remove once fixed.
    '& .MuiDataGrid-cellCheckbox .Mui-checked.Mui-disabled': {
      color: theme.palette.primary[400]
    },
    '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
      // No select-all here: a header checkbox would mean assigning every flag
      // in the region to this tenant.
      display: 'none'
    }
  },
  // Sits in the always-visible row rather than inside the collapsible filter
  // panel: GA flags are hidden by default, so the control that reveals them
  // cannot itself be hidden behind a closed panel.
  gaToggle: {
    marginLeft: 'auto',
    alignSelf: 'center'
  }
}));

export default createClasses;
